import { render, staticRenderFns } from "./receivablesStatistics.vue?vue&type=template&id=a6512746"
import script from "./receivablesStatistics.vue?vue&type=script&lang=js"
export * from "./receivablesStatistics.vue?vue&type=script&lang=js"
import style0 from "./receivablesStatistics.vue?vue&type=style&index=0&id=a6512746&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports